import styled from 'styled-components/macro'

import { Tag } from '@loadsmart/miranda-react'

export const CapitalizedTag = styled(Tag)`
  text-transform: capitalize;
`

export const ShipperLogo = styled.img`
  max-width: 110px;
  object-fit: contain;
`
